<template>
  <section class="bg-message-image">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 relative font-message ">
      <div class="relative">
        <!-- Section header -->
        <div class="max-w-xl mx-auto text-center pt-16 pb-12 md:pb-16">
          <p
            class="h4 font-normal text-theme-900 mt-12"
            data-aos="fade-up"
          >
            自宅にいながらオンラインでストレッチ、エクササイズ、ヨガ（今後予定）、健康セミナー（座学）が受け放題。<br />
            豊富なジャンルとプログラムを用意して毎月30〜50（今後増えていく予定）レッスンを配信。動画配信や生ライブを通して自宅にいながら健康的なライフスタイルを送ることができます。<br />
          </p>
          <p
            class="h4 font-normal text-theme-900 mt-12 "
            data-aos="fade-up"
          >
          <span class="underline-100">
            こんな方は、ぜひ私にお任せください。
          </span>
          <ul class="text-left mt-4 sm:pl-12" style="font-size: 1.1rem;">
            <li>・何か健康に対する取り組みを始めたいと思っている方</li>
            <li>・運動不足を解消したい方</li>
            <li>・元気が欲しい方</li>
            <li>・デスクワークで体が凝り固まっている方</li>
            <li>・自分の体の悩みを自分で解決できる方法を知りたい方</li>
            <li>・睡眠の質が低下していると自覚している方</li>
            <li>・美ボディを手に入れたい方</li>
            <li>・ダイエットを成功させたい方</li>
            <li>・ジムやマッサージ、整体に通うのが面倒な方</li>
            <li>・ずっと首肩こりに悩んでいる方</li>
            <li>・慢性腰痛に悩んでいる方</li>
          </ul>
          </p>
          <p
            class="h4 font-normal text-theme-900 mt-12"
            data-aos="fade-up"
          >
            参加いただければ、あなたの身体的不調を自分で解決するのはもちろん、これから不調が出た時に自分で解決する方法やスキル、知識を習得することができます。このサービスのゴールは、自分の健康を自分で守り、そして健康で元気でい続けることです。今抱えている身体の悩みを手放せることお約束いたします。さあ一緒に、今より健康で元気な日常生活を送っていきましょう。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "DescriptionKaradaSupport",
  components: {},
  data: function () {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.bg-message-image {
  background-image: url("./../images/message-background.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  .font-message {
    .h4 {
      line-height: 1.6;
    }
  }
}

.underline-100 {
  position: relative;

  &::after {
   content:"";
   display:block;
   height:8px;
   background-color: rgba(#3CA8F6, 0.4);
   position:absolute;
   bottom:0;
   left:0px;
   right:0px;
   z-index: -1;
  }
}
</style>
